import type { GameState } from '../api/types';

/** お題の解禁まで、あと何件スポットをクリアすればよいか（024）。解禁済み・設定なしなら 0 */
export function promptsLockRemaining(s: GameState | null): number {
  if (!s) return 0;
  const need = s.event.prompts_unlock_spots ?? 0;
  return Math.max(0, need - (s.team.spot_clears ?? 0));
}

/** カードを1枚も手に入れていないあいだはカードのタブを開けない（使用済みも手に入れた数に入る） */
export function cardsLocked(s: GameState | null): boolean {
  return !!s && s.cards.length === 0;
}
